import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FundraisingSummaryResponseNormalized } from '../../../../../../store/home/capture/types';

import { PendingRedemptionItemDesktop } from './Desktop';
import { PendingRedemptionItemMobile } from './Mobile';

export declare interface PendingRedemptionItemTypes {
  item: FundraisingSummaryResponseNormalized;
}

export const PendingRedemptionItem: React.FC<PendingRedemptionItemTypes> = (props) => {
  return useBreakpointValue({
    base: <PendingRedemptionItemMobile {...props} />,
    sm: <PendingRedemptionItemDesktop {...props} />,
  });
};
